var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionsLookup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#3F7CDB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0206 19.0779L22.876 21.9326L21.9326 22.8759L19.078 20.0206C18.0158 20.8721 16.6946 21.3352 15.3333 21.3333C12.0213 21.3333 9.33329 18.6453 9.33329 15.3333C9.33329 12.0213 12.0213 9.33325 15.3333 9.33325C18.6453 9.33325 21.3333 12.0213 21.3333 15.3333C21.3352 16.6946 20.8721 18.0157 20.0206 19.0779ZM18.6833 18.5833C19.5294 17.7132 20.0019 16.5469 20 15.3333C20 12.7546 17.9113 10.6666 15.3333 10.6666C12.7546 10.6666 10.6666 12.7546 10.6666 15.3333C10.6666 17.9113 12.7546 19.9999 15.3333 19.9999C16.5469 20.0018 17.7132 19.5293 18.5833 18.6833L18.6833 18.5833Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionsLookup);
export default __webpack_public_path__ + "static/media/actions-lookup.1b67b6d6d40c4cd927ee7e0e0e3c61c4.svg";
export { ForwardRef as ReactComponent };